var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor-container"},[_c('div',{attrs:{"id":"gjs"}}),_vm._v(" "),(_vm.showToolbar)?_c('div',{staticClass:"custom-toolbar"},[_c('button',{on:{"click":_vm.saveContent}},[_vm._v("保存")]),_vm._v(" "),_c('button',{on:{"click":_vm.previewContent}},[_vm._v("预览")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fac60f48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageBuilder.vue
// module id = null
// module chunks = 